import React from "react";
import {
  AreaChart,
  linearGradient,
  Tooltip,
  Area,
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  Scatter,
  ScatterChart,
  ZAxis,
  Legend,
  FunnelChart,
  Funnel,
  Cell,
  LabelList,
} from "recharts";
import clsx from "clsx";
import useInterval from "@rooks/use-interval";
import { useEffect, useState, useContext } from "react";
import { ConfigContext } from "../../../contexts/ConfigContext";

import axios from "../../../api/axios";

import CustomTooltip from "../../../utils/CustomTooltip";
import useAuth from "../../../hooks/authenticate/useAuth";
import useConfig from "../../../hooks/useConfig";

var request_updateTimelineData_safe = true;

var offset = new Date().getTimezoneOffset() / 60;
if (offset < 0) {
  offset *= -1;
  offset = Math.floor(offset);
}

function getLocalHour(date) {
  if (date) {
    let hour = new Date(date).getHours();
    return hour < 10 ? `0${hour}:00` : `${hour}:00`;
  }
}
function findHourData(timeline, hour) {
  for (let i = 0; i < timeline.length; i++) {
    if (timeline[i]["hour"] === hour) {
      return timeline[i];
    }
  }
  return -1;
}

function scatterTimelineLogic(timeline) {
  let data = [];
  let set = new Set();
  for (let i = 0; i < timeline.length; i++) {
    if (i === 0) {
      set.add(timeline[i]["hour"]);
      let arg = [];
      arg.push({
        dimX: timeline[i]["dimX"],
        dimY: timeline[i]["dimY"],
        area: parseFloat(
          (timeline[i]["dimX"] * timeline[i]["dimY"]).toFixed(4)
        ),
      });
      for (let j = i + 1; j < timeline.length; j++) {
        if (timeline[i]["hour"] === timeline[j]["hour"]) {
          arg.push({
            dimX: timeline[j]["dimX"],
            dimY: timeline[j]["dimY"],
            area: parseFloat(
              (timeline[j]["dimX"] * timeline[j]["dimY"]).toFixed(4)
            ),
          });
        }
      }
      let r = 90;
      let g = 160;
      let b = 70;
      data.push({
        data: arg.slice(0, 100),
        hour: timeline[i]["hour"],
        rbg: `rbg(${r},${g},${b})`,
      });
    } else if (!set.has(timeline[i]["hour"])) {
      set.add(timeline[i]["hour"]);
      let arg = [];
      let hour = parseInt(timeline[i]["hour"].split(":")[0]);
      arg.push({
        dimX: timeline[i]["dimX"],
        dimY: timeline[i]["dimY"],
        area: parseFloat(
          (timeline[i]["dimX"] * timeline[i]["dimY"]).toFixed(4)
        ),
      });
      for (let j = i + 1; j < timeline.length; j++) {
        if (timeline[i]["hour"] === timeline[j]["hour"]) {
          arg.push({
            dimX: timeline[j]["dimX"],
            dimY: timeline[j]["dimY"],
            area: parseFloat(
              (timeline[j]["dimX"] * timeline[j]["dimY"]).toFixed(4)
            ),
          });
        }
      }
      let r =
        hour < 5
          ? hour * 10 + 60
          : hour < 11
          ? hour * 10
          : hour < 17
          ? 256 - hour * hour - hour
          : hour * 10;
      let g =
        hour < 5
          ? 200 - hour * 10 - 20
          : hour < 11
          ? hour * 10 + 40
          : hour < 18
          ? 100 + hour * 3
          : hour * 2 + hour * 3 - 30;
      let b =
        hour < 5
          ? r * 2 + hour
          : hour < 9
          ? r * 2 - 60
          : hour < 18
          ? 200 - g
          : 200 - hour * 7;
      // console.log(`rgb(${r},${g},${b})`);
      // console.log(timeline[i]["hour"]);
      data.push({
        data: arg.slice(0, 400),
        hour: timeline[i]["hour"],
        rgb: `rgb(${r},${g},${b})`,
      });
    }
  }

  return data;
}

function fillLine(timeline) {
  let temp = [];

  // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
  for (let i = 0; i <= new Date().getHours(); i++) {
    let hour = i < 10 ? `0${i}:00` : `${i}:00`;
    let res = findHourData(timeline, hour);

    if (res !== -1) {
      temp.push(res);
    } else {
      temp.push({
        hour: hour,
        data: [
          {
            dimX: 0,
            dimY: 0,
            dimXY: 0,
          },
        ],
        rgb: "rgb(0,0,0)",
      });
    }
  }
  return temp;
}
// const CustomTooltips = ({ active, payload, label }) => {
//   console.log(`payload ${payload[1]} `);

//   if (active && payload && payload.length) {
//     if (
//       payload[0] &&
//       payload[1] &&
//       payload[0].value === 0 &&
//       payload[1].value === 0
//     ) {
//       return null;
//     } else if (payload[0] && payload[0].value === 0) {
//       return null;
//     } else if (payload[1] && payload[1].value === 0) {
//       return null;
//     }

//     return (
//       <div className="bg-white shadow-xl p-4 text-sm border rounded-md space-y-1 animate-fadeIn">
//         {payload[0] && (
//           <p
//             className={clsx({
//               "text-blue-500": payload[0].dataKey === "dimX",
//             })}
//           >{` ${payload[0].value.toLocaleString()}`}</p>
//         )}
//         {payload[1] && (
//           <p
//             className={clsx({
//               "text-green-500": payload[1].dataKey === "outCount",
//             })}
//           >{`${payload[1].value.toLocaleString()}`}</p>
//         )}

//         {/* <p className="text-gray-400">Total: {totalVisits.toLocaleString()}</p> */}
//       </div>
//     );
//   }

//   return null;
// };

const ChartDimensionToday = () => {
  const [timelineData, setTimelineData] = useState([]);
  const { auth } = useAuth();
  const [finishSetup, setFinishSetup] = useState(false);

  const [loading, setLoading] = useState(true);

  function updateTimelineData() {
    if (request_updateTimelineData_safe === false) {
      return;
    } else {
      request_updateTimelineData_safe = false;
    }
    axios
      .get(
        `/v1/statistics/dimension/hour?token=${
          auth.token
        }&day=${new Date().getUTCDate()}&month=${new Date().getUTCMonth() + 1}`
      )
      .then((res) => {
        let timeline = [];
        let scatterChart = [];
        for (let i = 0; i < res.data.length; i++) {
          for (let j = 0; j < res.data[i].length; j++) {
            // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
            if (
              parseInt(res.data[i][j]["hour"].split(":")[0]) <=
              new Date().getHours()
            ) {
              let dimXY = res.data[i][j]["dimXY"];
              dimXY = dimXY.filter(
                (vals) => vals["dim(X)"] > 0 && vals["dim(Y)"] > 0
              );
              dimXY.forEach((val) => {
                timeline.push({
                  hour: getLocalHour(res.data[i][j]["date"]),
                  dimX: parseFloat(val["dim(X)"].toFixed(3)),
                  dimY: parseFloat(val["dim(Y)"].toFixed(3)),
                });
              });
            }
          }
        }
        // TODO: need to check if this if needed
        // if (JSON.stringify(timelineData) !== JSON.stringify(resData)) {
        timeline = scatterTimelineLogic(timeline);
        // scatterChart
        timeline = fillLine(timeline);
        setFinishSetup(true);

        setTimelineData((prev) => timeline);
        // setLoading(false);
        // if (totalCountVehicles !== totalVehicles) {
        //   setTotalCountVehicles((prev) => totalVehicles);
        // }
        request_updateTimelineData_safe = true;
      })
      .catch((err) => {
        console.log(
          "error with get hour statistic inside today vehicles-> ",
          err
        );
      });
  }

  useEffect(() => {
    updateTimelineData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Get the up-to-date data for the in-out chart every 1 sec
  useInterval(
    () => {
      if (finishSetup) {
        updateTimelineData();
        setLoading(false);
      } else updateTimelineData();
    },
    30000,
    true
  );

  if (loading) {
    return (
      <div className="bg-gray-300 flex-auto w-full h-full rounded-md overflow-hidden transition-all">
        <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent  animate-slide"></div>
      </div>
    );
  }

  return (
    <div className=" w-full h-full">
      <div className="h-full w-full bg-gray-100 bg-opacity-50">
        <ResponsiveContainer>
          <ScatterChart margin={{ top: 20, right: 20, left: 20, bottom: 20 }}>
            <CartesianGrid strokeDasharray="3 3" />

            <XAxis
              axisLine={false}
              //   unit={`pixels`}
              name={"dim X"}
              type="number"
              tick={{ fontSize: "0.5rem" }}
              unit={"dimX"}
              //   unit={"cm"}
              //   interval="preserveStartEnd"
              // interval={0}
              // angle={-10}
              // dx={20}
              // dy={10}
              height={15}
              dataKey="dimX"
            />
            <YAxis
              axisLine={false}
              tickLine={true}
              type="number"
              name="dim Y"
              unit={"dimY"}
              //   unit={"cm"}
              //   unit={`pixels`}
              // mirror={true}
              tick={{ fontSize: "0.6rem" }}
              // allowDataOverflow={false}
              // tickMargin={5}
              width={30}
              // dx={10}
              // hide={true}
              interval="preserveStartEnd"
              dataKey="dimY"
            />
            <ZAxis dataKey={"area"} />
            <Tooltip
              coordinate={{ x: 0, y: 0 }}
              offset={0}
              allowEscapeViewBox={{ x: false, y: true }}
              cursor={{ strokeDasharray: "3 3" }}
              //   content={<CustomTooltips />}
            />
            <Legend />
            {timelineData.map((data, index) => (
              // data["data"].map((val, pos) => (
              <Scatter
                id={index}
                name={`hour: ${data["hour"]}`}
                fontSize={`10px`}
                key={data["hour"]}
                data={data["data"]}
                fill={data["rgb"]}
              >
                {/* {data["data"].map((val, pos) => (
                  <Cell
                    key={`cell-hour:${data["hour"] + pos}`}
                    strokeWidth={Math.round(val["dimX"] * 1000)}
                    fill={data["rgb"]}
                  />
                ))} */}
              </Scatter>
            ))}
          </ScatterChart>
        </ResponsiveContainer>
      </div>
    </div>
  );

  //OTHER LOGIC TGO SAVE FOR THE FUTURE
  // return (
  //   <div className="p-4">
  //     <div className=" font-semibold text-lg text-gray-600 px-2.5 pt-2">
  //       West To East Count
  //     </div>
  //     <div className="w-full 2xl:h-56 xl:h-60 bg-gray-100 bg-opacity-50">
  //       <ResponsiveContainer>
  //         <AreaChart
  //           data={toEast !== undefined ? toEast : toWest}
  //           margin={{ top: 10, right: 0, left: 0, bottom: 0 }}
  //         >
  //           <defs>
  //             {/* <linearGradient id="leaving" x1="0" y1="0" x2="0" y2="1">
  //             <stop offset="100%" stopColor="rgb(156, 163, 175)" />
  //           </linearGradient> */}
  //             <linearGradient
  //               id={toEast !== undefined ? "northToEast" : "eastToNorth"}
  //               x1="0"
  //               y1="0"
  //               x2="0"
  //               y2="1"
  //             >
  //               <stop
  //                 offset="100%"
  //                 stopColor="rgb(59, 130, 246)"
  //                 opacity={0.6}
  //               />
  //             </linearGradient>
  //             <linearGradient
  //               id={toEast !== undefined ? "westToEast" : "eastToWest"}
  //               x1="0"
  //               y1="0"
  //               x2="0"
  //               y2="1"
  //             >
  //               <stop
  //                 offset="100%"
  //                 stopColor="rgb(59, 246, 87)"
  //                 opacity={0.6}
  //               />
  //             </linearGradient>
  //           </defs>
  //           <Tooltip
  //             coordinate={{ x: 0, y: 0 }}
  //             offset={0}
  //             allowEscapeViewBox={{ x: false, y: true }}
  //             content={<CustomTooltip />}
  //           />
  //           <XAxis
  //             axisLine={false}
  //             tick={{ fontSize: "0.5rem" }}
  //             interval="preserveStartEnd"
  //             // interval={0}
  //             // angle={-10}
  //             // dx={20}
  //             // dy={10}
  //             height={15}
  //             dataKey="hour"
  //           />
  //           <YAxis
  //             axisLine={false}
  //             tickLine={true}
  //             // mirror={true}
  //             tick={{ fontSize: "0.6rem" }}
  //             // allowDataOverflow={false}
  //             // tickMargin={5}
  //             width={30}
  //             // dx={10}
  //             // hide={true}
  //             interval="preserveStartEnd"
  //             dataKey="total"
  //           />

  //           <Area
  //             type="natural"
  //             dataKey={toEast !== undefined ? "northToEast" : "eastToNorth"}
  //             stroke="rgb(59, 130, 246)"
  //             strokeWidth={2.5}
  //             fillOpacity={0.2}
  //             fill={
  //               toEast !== undefined ? "url(#northToEast)" : "url(#eastToNorth)"
  //             }
  //           />
  //           <Area
  //             type="natural"
  //             dataKey={toEast !== undefined ? "westToEast" : "eastToWest"}
  //             stroke="rgb(59, 246, 87)"
  //             strokeWidth={2.5}
  //             fillOpacity={0.2}
  //             fill={
  //               toEast !== undefined ? "url(#westToEast)" : "url(#eastToWest)"
  //             }
  //           />
  //         </AreaChart>
  //       </ResponsiveContainer>
  //     </div>
  //   </div>
  // );

  // <div className="p-4">
  //   <div className=" font-semibold text-lg text-gray-600 px-2.5 pt-2">
  //     West To East Count
  //   </div>
  //   <div className="w-full 2xl:h-56 xl:h-60 bg-gray-100 bg-opacity-50">
  //     <ResponsiveContainer>
  //       <AreaChart
  //         data={toEast !== undefined ? toEast : toWest}
  //         margin={{ top: 10, right: 0, left: 0, bottom: 0 }}
  //       >
  //         <defs>
  //           {/* <linearGradient id="leaving" x1="0" y1="0" x2="0" y2="1">
  //             <stop offset="100%" stopColor="rgb(156, 163, 175)" />
  //           </linearGradient> */}
  //           <linearGradient
  //             id={toEast !== undefined ? "northToEast" : "eastToNorth"}
  //             x1="0"
  //             y1="0"
  //             x2="0"
  //             y2="1"
  //           >
  //             <stop
  //               offset="100%"
  //               stopColor="rgb(59, 130, 246)"
  //               opacity={0.6}
  //             />
  //           </linearGradient>
  //           <linearGradient
  //             id={toEast !== undefined ? "westToEast" : "eastToWest"}
  //             x1="0"
  //             y1="0"
  //             x2="0"
  //             y2="1"
  //           >
  //             <stop
  //               offset="100%"
  //               stopColor="rgb(59, 246, 87)"
  //               opacity={0.6}
  //             />
  //           </linearGradient>
  //         </defs>
  //         <Tooltip
  //           coordinate={{ x: 0, y: 0 }}
  //           offset={0}
  //           allowEscapeViewBox={{ x: false, y: true }}
  //           content={<CustomTooltip />}
  //         />
  //         <XAxis
  //           axisLine={false}
  //           tick={{ fontSize: "0.5rem" }}
  //           interval="preserveStartEnd"
  //           // interval={0}
  //           // angle={-10}
  //           // dx={20}
  //           // dy={10}
  //           height={15}
  //           dataKey="hour"
  //         />
  //         <YAxis
  //           axisLine={false}
  //           tickLine={true}
  //           // mirror={true}
  //           tick={{ fontSize: "0.6rem" }}
  //           // allowDataOverflow={false}
  //           // tickMargin={5}
  //           width={30}
  //           // dx={10}
  //           // hide={true}
  //           interval="preserveStartEnd"
  //           dataKey="total"
  //         />

  //         <Area
  //           type="natural"
  //           dataKey={toEast !== undefined ? "northToEast" : "eastToNorth"}
  //           stroke="rgb(59, 130, 246)"
  //           strokeWidth={2.5}
  //           fillOpacity={0.2}
  //           fill={
  //             toEast !== undefined ? "url(#northToEast)" : "url(#eastToNorth)"
  //           }
  //         />
  //         <Area
  //           type="natural"
  //           dataKey={toEast !== undefined ? "westToEast" : "eastToWest"}
  //           stroke="rgb(59, 246, 87)"
  //           strokeWidth={2.5}
  //           fillOpacity={0.2}
  //           fill={
  //             toEast !== undefined ? "url(#westToEast)" : "url(#eastToWest)"
  //           }
  //         />
  //       </AreaChart>
  //     </ResponsiveContainer>
  //   </div>
  // </div>
  //  :
  // <div className="p-4">
  // <div className=" font-semibold text-lg text-gray-600 px-2.5 pt-2">
  //   West To East Count
  // </div>
  // <div className="w-full 2xl:h-56 xl:h-60 bg-gray-100 bg-opacity-50">
  //   <ResponsiveContainer>
  //     <AreaChart
  //       data={toWest}
  //       margin={{ top: 10, right: 0, left: 0, bottom: 0 }}
  //     >
  //       <defs>
  //         {/* <linearGradient id="leaving" x1="0" y1="0" x2="0" y2="1">
  //           <stop offset="100%" stopColor="rgb(156, 163, 175)" />
  //         </linearGradient> */}
  //         <linearGradient id="northToEast" x1="0" y1="0" x2="0" y2="1">
  //           <stop
  //             offset="100%"
  //             stopColor="rgb(59, 130, 246)"
  //             opacity={0.8}
  //           />
  //         </linearGradient>
  //         <linearGradient id="westToEast" x1="0" y1="0" x2="0" y2="1">
  //           <stop
  //             offset="100%"
  //             stopColor="rgb(59, 246, 87)"
  //             opacity={0.6}
  //           />
  //         </linearGradient>
  //       </defs>
  //       <Tooltip
  //         key={id}
  //         coordinate={{ x: 0, y: 0 }}
  //         offset={0}
  //         allowEscapeViewBox={{ x: false, y: true }}
  //         content={<CustomTooltip />}
  //       />
  //       <XAxis
  //         axisLine={false}
  //         tick={{ fontSize: "0.5rem" }}
  //         interval="preserveStartEnd"
  //         // interval={0}
  //         // angle={-10}
  //         // dx={20}
  //         // dy={10}
  //         height={15}
  //         dataKey="hour"
  //       />
  //       <YAxis
  //         axisLine={false}
  //         tickLine={true}
  //         // mirror={true}
  //         tick={{ fontSize: "0.6rem" }}
  //         // allowDataOverflow={false}
  //         // tickMargin={5}
  //         width={30}
  //         // dx={10}
  //         // hide={true}
  //         interval="preserveStartEnd"
  //         dataKey="total"
  //       />
  //       <Area
  //         type="natural"
  //         dataKey="northToEast"
  //         stroke="rgb(59, 130, 246)"
  //         strokeWidth={2.5}
  //         fillOpacity={0.2}
  //         fill="url(#northToEast)"
  //       />
  //       <Area
  //         type="natural"
  //         dataKey="westToEast"
  //         stroke="rgb(59, 246, 87)"
  //         strokeWidth={2.5}
  //         fillOpacity={0.2}
  //         fill="url(#westToEast)"
  //       />
  //     </AreaChart>
  //   </ResponsiveContainer>
  // </div>

  // return (
  //   <div className="p-4">
  //     <div className="w-full h-32 bg-gray-100 bg-opacity-50">
  //       <ResponsiveContainer>
  //         <AreaChart
  //           data={timelineData}
  //           margin={{ top: 10, right: 0, left: 0, bottom: 0 }}
  //         >
  //           <defs>
  //             {/* <linearGradient id="leaving" x1="0" y1="0" x2="0" y2="1">
  //               <stop offset="100%" stopColor="rgb(156, 163, 175)" />
  //             </linearGradient> */}
  //             <linearGradient id="vehicles" x1="0" y1="0" x2="0" y2="1">
  //               <stop offset="100%" stopColor="rgb(59, 130, 246)" />
  //             </linearGradient>
  //           </defs>
  //           <Tooltip
  //             coordinate={{ x: 0, y: 0 }}
  //             offset={0}
  //             allowEscapeViewBox={{ x: false, y: true }}
  //             content={<CustomTooltip />}
  //           />
  //           <XAxis
  //             axisLine={false}
  //             tick={{ fontSize: "0.5rem" }}
  //             interval="preserveStartEnd"
  //             // interval={0}
  //             // angle={-10}
  //             // dx={20}
  //             // dy={10}
  //             height={15}
  //             dataKey="hour"
  //           />
  //           <YAxis
  //             axisLine={false}
  //             tickLine={true}
  //             // mirror={true}
  //             tick={{ fontSize: "0.6rem" }}
  //             // allowDataOverflow={false}
  //             // tickMargin={5}
  //             width={30}
  //             // dx={10}
  //             // hide={true}
  //             interval="preserveStartEnd"
  //             dataKey="vehicles"
  //           />
  //           {
  //             <Area
  //               type="natural"
  //               dataKey="vehicles"
  //               stroke="rgb(59, 130, 246)"
  //               strokeWidth={2.5}
  //               fillOpacity={0.2}
  //               fill="url(#vehicles)"
  //             />
  //           }
  //         </AreaChart>
  //       </ResponsiveContainer>
  //     </div>
  //   </div>
  // );
  // };
};

export default ChartDimensionToday;
